export default "__VITE_ASSET__CjfF6_AS__"